module.exports = __webpack_public_path__ + "img/color-logo.92e9a5b9.svg";